import { createContext, type ReactNode } from "react";

// Bridges subtitle content from AppDatePicker into AppMonthCaption; needed
// because react-day-picker invokes its `components` slots with a fixed signature.
export const MonthSubtitleContext = createContext<ReactNode>(null);
